import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import VideoCard from '../components/VideoCard';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { History, ThumbsUp, Clock, Users, Loader2 } from 'lucide-react';
import { myHistory, myLiked, myWatchLater, mySubscriptions, resolveFileUrl } from '../lib/api';
import { toast } from 'sonner';

export default function Library() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get('tab') || 'history';
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [liked, setLiked] = useState([]);
  const [later, setLater] = useState([]);
  const [subs, setSubs] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      const [h, l, w, s] = await Promise.all([ myHistory(), myLiked(), myWatchLater(), mySubscriptions() ]);
      setHistory(h); setLiked(l); setLater(w); setSubs(s);
    } catch (err) { toast.error('Failed to load library'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div>
      <div className="chip">Library</div>
      <h1 className="font-display text-[32px] md:text-[40px] mt-3 leading-none">Your library</h1>

      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v })} className="mt-6">
        <TabsList className="bg-white/[0.04] border border-white/10">
          <TabsTrigger value="history"><History className="w-4 h-4 mr-2" /> History</TabsTrigger>
          <TabsTrigger value="liked"><ThumbsUp className="w-4 h-4 mr-2" /> Liked</TabsTrigger>
          <TabsTrigger value="watchlater"><Clock className="w-4 h-4 mr-2" /> Watch later</TabsTrigger>
          <TabsTrigger value="subs"><Users className="w-4 h-4 mr-2" /> Subscriptions</TabsTrigger>
        </TabsList>

        {loading ? (
          <div className="flex items-center gap-2 text-white/60 py-10"><Loader2 className="w-5 h-5 animate-spin" /> Loading…</div>
        ) : (<>
          <TabsContent value="history" className="mt-6"><Grid list={history} empty="You haven’t watched anything yet." onChanged={load} /></TabsContent>
          <TabsContent value="liked" className="mt-6"><Grid list={liked} empty="No liked videos yet." onChanged={load} /></TabsContent>
          <TabsContent value="watchlater" className="mt-6"><Grid list={later} empty="Nothing saved for later." onChanged={load} /></TabsContent>
          <TabsContent value="subs" className="mt-6">
            {subs.length === 0 ? <div className="text-white/55">You’re not subscribed to any channels yet.</div> : (
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {subs.map(c => (
                  <Link key={c.id} to={`/channel/${c.id}`} className="card-shell p-4 flex items-center gap-3 hover-lift">
                    <img src={resolveFileUrl(c.avatar)} alt={c.name} className="w-14 h-14 rounded-full object-cover" />
                    <div>
                      <div className="font-semibold">{c.name}</div>
                      <div className="text-[12.5px] text-white/55">{c.handle}</div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </TabsContent>
        </>)}
      </Tabs>
    </div>
  );
}

function Grid({ list, empty, onChanged }) {
  if (list.length === 0) return <div className="text-white/55">{empty}</div>;
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
      {list.map(v => <VideoCard key={v.id} video={v} onChanged={onChanged} />)}
    </div>
  );
}
